import React, { useState, useEffect } from "react";
import { PageHeader, ListGroup, ListGroupItem, ControlLabel, FormGroup, FormControl, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./Home.css";
import { API } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import Input from '../components/Input';

export default function Home(props) {
  const aprobadores = ['efiallos@senasa.gob.hn','lortiz@senasa.gob.hn','fraudales@senasa.gob.hn','eavila@senasa.gob.hn','jbarrios@senasa.gob.hn'];
  const consultores = ['jmaradiaga@oirsa.org','nhernandez@oirsa.org','sepa.henecan.hn@oirsa.org','sepa.puertocortes.hn@oirsa.org','sepa.lasmanos.hn@oirsa.org','sepa.elamatillo.hn@oirsa.org','sepa.villedamorales.hn@oirsa.org','sepa.toncontin.hn@oirsa.org','sepa.guasaule.hn@oirsa.org','sepa.aguacaliente.hn@oirsa.org','sepa.elflorido.hn@oirsa.org','sepa.corinto.hn@oirsa.org','sepa.elpoy.hn@oirsa.org','sepa.roatan.hn@oirsa.org','sepa.puertocastilla.hn@oirsa.org','sepa.fraternidad.hn@oirsa.org','sepa.goloson.hn@oirsa.org'];
  const supervisores = ['jvelasquez@senasa.gob.hn','bosorio@senasa.gob.hn','kschumacher@senasa.gob.hn','cesar.espinoza@ssvhonduras.org','henry.rodriguez@ssvhonduras.org'];
  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [usuario_registro, setUsuarioRegistro] = useState(props.email);
  const [isObserver, setObserver] = useState(false);
  const [isConsulta, setConsulta] = useState(false);
  const [isSupervisor, setSupervisor] = useState(false);
  const [numero_permiso, setNumeroPermiso] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [URL, setURL] = useState("");
  
  const d = new Date();
  const [fecha_inicio,setFechaInicio] = useState(new Date(d.getFullYear(),d.getMonth(),d.getDate()).toJSON().slice(0, 10));
  const [fecha_fin,setFechaFin] = useState(new Date(d.getFullYear(),d.getMonth(),d.getDate()).toJSON().slice(0, 10));
  
  useEffect(() => {
    async function onLoad() { 
      if (!props.isAuthenticated) {
        return;
      }

      try {
        const notes = await loadNotes();
		if (notes==null) {
		    setNotes(null);	
		} else {
        	setNotes(notes.rows);
		}
      } catch (e) {
        alert(e);
      }

      setIsLoading(false);
    }

    onLoad();
  }, [usuario_registro, props.isAuthenticated]);
  
  function formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
  }
  

  function loadNotes() {
	  //usuarios Supervisores
	  if (supervisores.find(item=>item==usuario_registro)) {
		  setSupervisor(true);
		  return API.get("notes","/estadisticas?fecha_inicio=" + fecha_inicio + "&fecha_fin=" + fecha_fin);
	  }
	  //usuarios Aprobadores
	  if (aprobadores.find(item=>item==usuario_registro)) {
	  	  setObserver(true);
		  return API.get("notes","/permisos?usuario_autoriza=" + usuario_registro)
	  }
	  //usuarios VIP 
	  if (usuario_registro=="tmcesar95@hotmail.com" || usuario_registro.includes("mentors.com") || usuario_registro=="soporte@ssvhonduras.org") {
		  setObserver(true);
		  if (usuario_registro=="soporte@ssvhonduras.org") {
			  return API.get("notes","/permisos?estatus_documento<>REGISTRADO&nl=lang");
		  } else {
	  	      return API.get("notes","/permisos?estatus_documento<>REGISTRADO");
		  }
	  }
	  if (usuario_registro=="katit7@gmail.com" || usuario_registro=="henry_jrd@yahoo.com" || consultores.find(item=>item==usuario_registro)) {
		  setConsulta(true);
		  return null;
	  }
	  
	  if (!isObserver) {
	  	  return API.get("notes","/permisos?usuario_registro=" + usuario_registro)
	  }
	      
  }
  
  async function getPermiso() {
  	  const permiso = await API.get("notes","permisos?estatus_documento=CERRADO&id=" + numero_permiso);
	  if (permiso.rows.length > 0) {
	  	 return "https://dte-gestiomas.s3-us-west-2.amazonaws.com/senasa/" + numero_permiso + ".pdf";
	  } else {
		  return "";
	  }
  }
  
  function handleChangeNumero(event) {
  	  setNumeroPermiso(event.target.value);
	  setShowResult(false);
  }
  
  async function handleGetPermiso() {
	  setIsLoading(true);
	  const result = await getPermiso();
	  setURL(result);
	  setIsLoading(false);
	  setShowResult(true);
	  setNumeroPermiso("");
  }
  
  async function handleRefresh() {
  	  setIsLoading(true);
	  const notes = await API.get("notes","/estadisticas?fecha_inicio=" + fecha_inicio + "&fecha_fin=" + fecha_fin);
  	  setNotes(notes.rows);
	  setIsLoading(false);
  }
  
  function mostrarResultado() {
	  if (URL=="") {
	  	return (
			<div>
				<ControlLabel>EL PERMISO EMITIDO NO EXISTE</ControlLabel>
		    </div>
	  	);
	  } else {
	  	return (
 		 	<FormGroup>
  				<FormControl.Static>
    	  		<a
      				target="_blank"
      				rel="noopener noreferrer"
      				href={URL}
    			>
      			  	{"Descargar Permiso"}
    			</a>
  				</FormControl.Static>
			</FormGroup>
				);
		}
  }

  function renderNotesList(notes,cerradas) {
    return [{}].concat(notes).map((note, i) =>
      i !== 0 ? (
        <LinkContainer key={note.id} to={`/notes/${note.id}`}>
          <ListGroupItem header={note.proveedor}>
            {"Creada: " + note.fecha_registro}
			{", Estatus: " + note.estatus_documento}
			{", ID: " + note.id}
          </ListGroupItem>
        </LinkContainer>
      ) : (!cerradas)? (!isObserver ? (
		  <LinkContainer key="new" to="/notes/new">
          <ListGroupItem>
            <h4>
              <b>{"\uFF0B"}</b> Crear una nueva solicitud
            </h4>
          </ListGroupItem>
        </LinkContainer> )
		  : (null)
	  ):(null)
    );
  }
  
  //usuario_autoriza	total_asignadas	en_revision	procesadas	rechazadas	autorizadas
  function renderRowsAprobadores(items) {
  	return [{}].concat(items).map((item,i) =>
		  i !== 0 ? (
		  	<tr>
			  <td>{i}</td>
			  <td>{item.usuario_autoriza}</td>
			  <td>{item.total_asignadas}</td>
			  <td>{item.en_revision}</td>
			  <td>{item.procesadas}</td>
			  <td>{item.rechazadas}</td>
			  <td>{item.autorizadas}</td>
			</tr>  
		  ) : (null)
	  )
  }
  
  //fecha_registro	solicitud	solicitado_por	revisado_por	establecimiento	producto	generico	estatus_producto	numero_tgr	monto_tgr
  function renderRowsTGRs(items) {
  	return [{}].concat(items).map((item,i) =>
		  i !== 0 ? (
		  	<tr>
			  <td>{i}</td>
			  <td>{item.fecha_registro}</td>
			  <td>{item.solicitud}</td>
			  <td>{item.solicitado_por}</td>
			  <td>{item.revisado_por}</td>
			  <td>{item.establecimiento}</td>
			  <td>{item.producto}</td>
			  <td>{item.estatus_producto}</td>
			  <td>{item.numero_tgr}</td>
			  <td>{item.monto_tgr}</td>
			</tr>  
		  ) : (null)
	  )
  }
  
  function sumRowsAprobadores(items) {
	  var total_asignadas = 0;
	  var total_en_revision = 0;
	  var total_procesadas = 0;
	  var total_rechazadas = 0;
	  var total_autorizadas = 0;
	  for (const item of items) {
	  	  total_asignadas += item.total_asignadas;
		  total_en_revision += item.en_revision;
		  total_procesadas += item.procesadas;
		  total_rechazadas += item.rechazadas;
		  total_autorizadas += item.autorizadas;
	  }
	  return (
		  	<tr>
			  <td></td>
			  <td>TOTALES</td>
			  <td>{total_asignadas}</td>
			  <td>{total_en_revision}</td>
			  <td>{total_procesadas}</td>
			  <td>{total_rechazadas}</td>
			  <td>{total_autorizadas}</td>
			</tr>
	  )
	  
  }
  
  //usuario_registro	nombre	establecimiento	total_emitidas	esperando_aprobacion	autorizadas	rechazadas
  function renderRowsImportadores(items) {
  	return [{}].concat(items).map((item,i) =>
		  i !== 0 ? (
		  	<tr>
			  <td>{i}</td>
			  <td>{item.usuario_registro}</td>
			  <td>{item.nombre}</td>
			  <td>{item.establecimiento}</td>
			  <td>{item.total_emitidas}</td>
			  <td>{item.esperando_aprobacion}</td>
			  <td>{item.autorizadas}</td>
			  <td>{item.rechazadas}</td>
			</tr>  
		  ) : (null)
	  )
  }
  
  function sumRowsImportadores(items) {
	  var total_emitidas = 0;
	  var total_esperando_aprobacion = 0;
	  var total_autorizadas = 0;
	  var total_rechazadas = 0;
	  for (const item of items) {
	  	  total_emitidas += item.total_emitidas;
		  total_esperando_aprobacion += item.esperando_aprobacion;
		  total_autorizadas += item.autorizadas;
		  total_rechazadas += item.rechazadas;
	  }
	  return (
		  	<tr>
		  	  <td></td>
			  <td></td>
			  <td></td>
			  <td>TOTALES</td>
			  <td>{total_emitidas}</td>
			  <td>{total_esperando_aprobacion}</td>
			  <td>{total_autorizadas}</td>
			  <td>{total_rechazadas}</td>
			</tr>
	  )
	  
  }
  
  
  function renderItemsAprobadores(items) {
	  return (
<Table responsive>
  <thead>
    <tr>
      <th>#</th>
      <th>Autorizador</th>
      <th>Total Asignadas</th>
      <th>En Revisión</th>
      <th>Procesadas</th>
      <th>Rechazadas</th>
	  <th>Autorizadas</th>
    </tr>
  </thead>
  <tbody>
	{renderRowsAprobadores(items)}
	{sumRowsAprobadores(items)}
  </tbody>
</Table> 		
  	);
  }
  
   //fecha_registro	solicitud	solicitado_por	revisado_por	establecimiento	producto	generico	estatus_producto	numero_tgr	monto_tgr
  function renderItemsTGRs(items) {
	  return (
<Table responsive>
  <thead>
    <tr>
      <th>#</th>
      <th>Fecha de Revisión</th>
	  <th>ID Solicitud</th>
      <th>Solicitado por</th>
      <th>Revisado por</th>
      <th>Establecimiento</th>
      <th>Producto</th>
	  <th>Estatus</th>
	  <th># TGR</th>
	  <th>Monto TGR</th>	  
    </tr>
  </thead>
  <tbody>
	{renderRowsTGRs(items)}
  </tbody>
</Table> 		
  	);
  }
  
  
  function renderItemsImportadores(items) {
	  return (
<Table responsive>
  <thead>
    <tr>
      <th>#</th>
      <th>Email</th>
      <th>Nombre</th>
      <th>Establecimiento</th>
      <th>Total Solicitudes Emitidas</th>
      <th>Esperando Aprobación</th>
	  <th>Autorizadas</th>
	  <th>Rechazadas</th>	  
    </tr>
  </thead>
  <tbody>
	{renderRowsImportadores(items)}
	{sumRowsImportadores(items)}
  </tbody>
</Table> 		
  	);
  }
  
  function renderItemsAuto() {
    return (
      <div className="notes">
	  <h1>Reporte de solicitudes asignadas por autorizador</h1>
      <ListGroup>
        {renderItemsAprobadores(notes.filter(item=>item.tipo=='AUTORIZADOR'))}
      </ListGroup>
      </div>
    );
  }
	
    function renderItemsImpo() {
      return (
        <div className="notes">
		  <h1>Reporte de solicitudes emitidas por importador</h1>
          <ListGroup>
            {renderItemsImportadores(notes.filter(item=>item.tipo=='IMPORTADOR'))}
          </ListGroup>
        </div>
      );
  }
  
  
  function renderItemsTGR() {
    return (
      <div className="notes">
	  <h1>Reporte de uso de TGRs</h1>
        <ListGroup>
          {renderItemsTGRs(notes.filter(item=>item.tipo=='TGR'))}
        </ListGroup>
      </div>
    );
  }
  
  

  function renderLander() {
    return (
      <div className="lander">
        <h1>Gestion de Permisos SENASA</h1>
        <p>Simplificando los tramites</p>
      </div>
    );
  }
  
  function labelSolicitante() {
  	return (!isObserver) ? ' Solicitudes Creadas: ' : ' Solicitudes en Proceso: '
  }
  
  function filterEstatusLista() {
	  return (!isObserver) ? 'REGISTRADO' : 'ENVIADO';
  }
  
  function renderEnviadas() {
  	return (
	  <div>
	  <PageHeader>Solicitudes Enviadas para Aprobación: </PageHeader>
	  {!isLoading && renderNotesList(notes.filter(item=>item.estatus_documento=='ENVIADO'),true)}
	  </div>
  	);
  }
  
  function renderNotes() {
    return (
      <div className="notes">
		<ControlLabel>Autenticado como: {usuario_registro}</ControlLabel>
        <ListGroup>
		  <div>
		  <PageHeader>{labelSolicitante()} </PageHeader>
          {!isLoading && renderNotesList(notes.filter(item=>item.estatus_documento==filterEstatusLista()),false)}
		  </div>
		  { 
			(!isObserver && renderEnviadas())
		  }
		  <div>
		  <PageHeader>Solicitudes Procesadas (Aprobadas en su totalidad): </PageHeader>
		  {!isLoading && renderNotesList(notes.filter(item=>(item.estatus_documento=='CERRADO' && !item.productos.includes("RECHAZADO"))),true)}
		  </div>
		  <div>
		  <PageHeader>Solicitudes Procesadas (Con rechazos): </PageHeader>
		  {!isLoading && renderNotesList(notes.filter(item=>(item.estatus_documento=='CERRADO' && item.productos.includes("RECHAZADO"))),true)}
		  </div>
        </ListGroup>
      </div>
    );
  }
  
  function renderButtonRefresh() {
    	return (
    	   <div className="notes">
            <Input inputType={'date'} 
             name={'fecha_inicio'}
             title= {'Desde:'} 
             value={fecha_inicio} 
             handleChange={e=>setFechaInicio(e.target.value)} />
            <Input inputType={'date'} 
              name={'fecha_fin'}
              title= {'Hasta:'} 
              value={fecha_fin} 
              handleChange={e=>setFechaFin(e.target.value)} />
      		<LoaderButton
        			  	block
        			  	type="submit"
        			  	bsSize="large"
  					    onClick={handleRefresh}
        			  	isLoading={isLoading}
        			  	disabled={false}
      			        >
        			  Actualizar los datos de los reportes
      		</LoaderButton>
		 </div> 
	 );
  }
  
  function consulta() {
  	return (
  	   <div className="notes">

				<Input inputType={'number'}
   			   		title= {'Ingrese el # de permiso:'} 
   	     	   	 	name= {'numero_permiso'}
   	   		   	 	value={numero_permiso} 
   			   	 	disabled={false}
   	   		   	 	placeholder = {'Ingrese #'}
   	   		   	 	handleChange = {handleChangeNumero}            
   		  	   />
    		<LoaderButton
      			  	block
      			  	type="submit"
      			  	bsSize="large"
					onClick={handleGetPermiso}
      			  	isLoading={isLoading}
      			  	disabled={false}
    			>
      			  Buscar
    		</LoaderButton>
	   </div>
  	);
  }

  return (
    <div className="Home">
	  {props.isAuthenticated && isConsulta && consulta() }
	  {props.isAuthenticated && isSupervisor && renderButtonRefresh()}
	  {props.isAuthenticated && isSupervisor && renderItemsAuto()}
	  {props.isAuthenticated && isSupervisor && renderItemsImpo()}
	  {props.isAuthenticated && isSupervisor && renderItemsTGR()}
	  {showResult && mostrarResultado()}
      {usuario_registro!="" && props.isAuthenticated && !isConsulta && !isSupervisor ? renderNotes() : renderLander()}
    </div>
  );
}
